import React from 'react';
import { IAuditoriaAnomaliaTarifaBancariaResultado } from '../interfaces/IAuditoriaAnomaliaTarifaBancaria';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaAnomaliaTarifaBancariaResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Anomalias em Tarifas Bancárias não é um tributo — é uma auditoria de classificação/
// estatística (sem cálculo de multa ou imposto), que detecta lançamentos desproporcionais (> 5x a
// média) ou com indício de juros/empréstimo/financiamento lançados na conta de tarifas bancárias.
// Segue o mesmo padrão de seção própria já usado para os outros módulos de auditoria.
const AuditoriaResumoAnomaliaTarifaBancaria: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.anomaliasDetectadas?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Anomalias em Tarifas Bancárias</h3>
      <p className='text-muted'>
        Auditoria de classificação — lançamentos desproporcionais (mais de 5x a média do período) ou com indício de
        juros/empréstimo/financiamento na conta de tarifas bancárias (Art. 47 Lei 4.506/64). Clique para ver a
        análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Valor em Anomalias</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_ANOMALIA_TARIFA_BANCARIA')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Anomalias em Tarifas Bancárias</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} anomalia{totalOcorrencias === 1 ? '' : 's'} identificada{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Sem multa/imposto — auditoria de classificação contábil.</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoAnomaliaTarifaBancaria;
